<template>
  <div class="home">
    <LoaderComponent v-show="loading" />
    <HeaderView />
    <section
      class="order-page-main-sec invoice-page-main-sec agency-design-grid-right"
    >
      <div class="desktop-respovsive-main-sec">
        <div class="invoice-history-content">
          <h2 class="text-heading">Order Receipts</h2>
          <div class="text-1">
            Review your billing history and receipts.
          </div>
        </div>

        <div class="editor-dashboard-sec-2">
          <div class="order-list-tabs">
            <div class="order-input-field">
              <!-- <div class="search-box">
                <div class="form-row">
                  <div class="col-md-12">
                    <label>Search</label>

                    <div class="form-group">
                      <button class="search-button">
                        <i class="fas fa-search"></i>
                      </button>
                      <input
                        type="text"
                        class="form-control"
                        id="formGroupExampleInput"
                        v-model="search.all_invoice"
                        placeholder="Search all invoices"
                      />
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="date-picker-box">
                <div class="form-row">
                  <div class="col-md-12">
                    <label>Filter by date</label>
                    <div class="input-daterange input-group" id="m_datepicker">
                      <DatePickerComponent
                        :minDate="minDate"
                        :maxDate="maxDate"
                        :options="options"
                        :position="position"
                        :refVal="'datepickerMenu'"
                        :orderDate="filter.order_date"
                        @getSearchData="getSearchData"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="download-icon-list">
                <div @click="downloadFile()" class="top_icons">
                  <i
                    class="fas fa-file-export"
                    v-b-tooltip.hover.top="'Export CSV'"
                  ></i>
                </div>
                <div class="per-page-right-box">
                  <div class="select-item">
                    <select
                      @change="changePagination()"
                      v-model="filter.per_page"
                    >
                      <option>50</option>
                      <option>100</option>
                      <option>200</option>
                      <option>500</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <form>
              <table class="addon-table">
                <tr>
                  <th>Transaction For</th>
                  <th>Payment Method</th>
                  <th>Amount</th>
                  <th>Date Created</th>
                  <th>Action</th>
                </tr>
                <tr v-for="billing in billingDetail" :key="billing.id">
                  <td>{{ billing.type == 'Order' ? billing.type + ' - ' + billing.order_id : billing.type}}</td>
                  <td>{{ billing.payment_method }}</td>
                  <td>{{ numberFormat(billing.amount, "currency") }}</td>
                  <td>{{ billing.created_at }}</td>
                  <td>
                    <div class="btn-box">
                      <a
                        :disabled="billing.type != 'Order' && billing.type != 'Balance' && billing.type != 'Custom' ? true : false"
                        href="javascript:;"
                        @click="viewInvoice(billing.invoice_hold, billing.id, billing.type)"
                        v-b-tooltip.hover.top="'View'"
                        ><i class="fas fa-eye"></i
                      ></a>
                    </div>
                  </td>
                </tr>
              </table>
            </form>
            <div class="total-records-list">
              <p>Showing {{ rows.length }} of {{ totalRecords }} records</p>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-list">
        <!-- <ul>
          <li>
            <a href="#"><i class="fas fa-chevron-left"></i> Prev</a>
          </li>
          <li><a href="#" class="active">1</a></li>
          <li><a href="#">2</a></li>
          <li><a href="#">3</a></li>
          <li><a href="#">4</a></li>
          <li><a href="#">5</a></li>
          <li>
            <a href="#">Next <i class="fas fa-chevron-right"></i></a>
          </li>
        </ul> -->
        <paginate
          :click-handler="getBillingDetail"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :page-count="filter.last_page"
          :page-range="3"
          :margin-pages="2"
          :container-class="'className'"
          :records="filter.length"
          v-model="filter.page"
          :per-page="filter.per_page"
        >
        </paginate>
      </div>
    </section>

    <!-- Wallet Top-Up Success Modal -->
    <b-modal
      v-model="showWalletTopupModal"
      id="modal-wallet-topup-success"
      class="wallet-topup-modal"
      centered
      :no-close-on-backdrop="true"
      hide-header
      hide-footer
    >
      <div class="wallet-topup-content">
        <button type="button" class="close-btn" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
        
        <!-- Header with icon, title and subtitle together -->
        <div class="modal-header-section">
          <div class="wallet-icon">
            <i class="fas fa-credit-card"></i>
            <i class="fas fa-plus plus-icon"></i>
          </div>
          <div class="title-subtitle-wrapper">
            <h2 class="modal-title">Wallet Top-Up Successful</h2>
            <p class="modal-subtitle">Your wallet balance has been updated successfully.</p>
          </div>
        </div>

        <!-- Amount Added in one line -->
        <div class="amount-section">
          <span class="amount-label">Amount Added</span>
          <span class="amount-value">{{ numberFormat(walletTopupData.amount, "currency") }} USD</span>
        </div>

        <!-- Receipt Details with heading -->
        <div class="receipt-section">
          <h3 class="receipt-heading">Receipt Details</h3>
          <div class="receipt-table">
            <div v-if="walletTopupData.paid_via_invoice && walletTopupData.invoice_no" class="receipt-row">
              <div class="receipt-label-cell">Invoice #:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">{{ walletTopupData.invoice_no }}</div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Transaction Type:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">Wallet Balance Top-Up</div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Date:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">{{ walletTopupData.date }}</div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Status:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">
                <i class="fas fa-check-circle status-completed"></i> Completed
              </div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Payment Method:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">{{ walletTopupData.payment_method }}</div>
            </div>
          </div>
        </div>

        <p class="info-text">Funds are instantly available for link orders and services.</p>

        <div class="action-btn-box">
          <button class="btn-order-links" @click="goToOrderLinks">
            Order Links
          </button>
        </div>

        <div class="security-message">
          <i class="fas fa-lock"></i>
          <span>Secure payment with encrypted transactions.</span>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showCustomPaymentModal"
      id="modal-custom-payment"
      class="wallet-topup-modal"
      centered
      :no-close-on-backdrop="true"
      hide-header
      hide-footer
    >
      <div class="wallet-topup-content">
        <button type="button" class="close-btn" @click="closeCustomModal">
          <i class="fas fa-times"></i>
        </button>

        <div class="modal-header-section">
          <div class="wallet-icon">
            <i class="fas fa-file-invoice"></i>
          </div>
          <div class="title-subtitle-wrapper">
            <h2 class="modal-title">Custom Payment</h2>
            <p class="modal-subtitle">Description and amount for this custom invoice item.</p>
          </div>
        </div>

        <div class="amount-section">
          <span class="amount-label">Amount</span>
          <span class="amount-value">{{ numberFormat(customPaymentData.amount, "currency") }} USD</span>
        </div>

        <div class="receipt-section">
          <h3 class="receipt-heading">Receipt Details</h3>
          <div class="receipt-table">
            <div v-if="customPaymentData.paid_via_invoice && customPaymentData.invoice_no" class="receipt-row">
              <div class="receipt-label-cell">Invoice #:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">{{ customPaymentData.invoice_no }}</div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Description:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">{{ customPaymentData.description || '—' }}</div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Date:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">{{ customPaymentData.date }}</div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Status:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">
                <i class="fas fa-check-circle status-completed"></i> Completed
              </div>
            </div>
            <div class="receipt-row">
              <div class="receipt-label-cell">Payment Method:</div>
              <div class="receipt-divider"></div>
              <div class="receipt-value-cell">{{ customPaymentData.payment_method }}</div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import DatePickerComponent from "@/components/DatePickerComponent.vue";
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import { numberFormat } from "@/prod.js";
import Paginate from "vuejs-paginate-next";
export default {
  components: {
    HeaderView,
    DatePickerComponent,
    Paginate,
    LoaderComponent,
  },

  mounted() {
    this.getBillingDetail();
  },
  data() {
    return {
      numberFormat,
      loading: false,
      form: {
        name: "",
        email: "",
        phone: "",
        company: "",
        password: "",
      },
      showPassword: false,
      filter: {
        s: "",
        e: "",
        order_date: "",
        columnTo: "id",
        orderBy: "desc",
        per_page: 50,
        page: 1,
        last_page: 1,
        length: "",
      },
      minDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
      paginationData: {},

      billingDetail: [],

      search: {
        s: "",
        e: "",
        all_invoice: "",
      },
      date: new Date(),
      dateFormat: "MM-dd-yyyy",
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false,
      },
      totalRecords: 0,
      rows: [],
      selectedRange: "",
      position: "left",
      showWalletTopupModal: false,
      showCustomPaymentModal: false,
      walletTopupData: {
        amount: "",
        date: "",
        payment_method: "",
        last4: "",
        invoice_no: "",
        paid_via_invoice: false,
      },
      customPaymentData: {
        amount: "",
        date: "",
        description: "",
        payment_method: "",
        invoice_no: "",
        paid_via_invoice: false,
      },
    };
  },
  methods: {
    getSearchData(value) {
      this.filter.order_date = value;
      this.getBillingDetailSearch();
    },
    async getBillingDetail() {
      this.loading = true;
      this.filter.s = this.filter.order_date ? this.filter.order_date[0] : "";
      this.filter.e = this.filter.order_date ? this.filter.order_date[1] : "";
      try {
        let res = await this.$store.dispatch(
          "Billing/getBillingDataAction",
          this.filter
        );
        this.billingDetail = res.data;
        this.paginationData = res;
        this.totalRecords = res.meta.total;
        this.rows = res.data;
        this.filter.page = res.meta.current_page;
        this.filter.per_page = res.meta.per_page;
        this.filter.last_page = res.meta.last_page;
        this.filter.length = res.meta.total;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    getBillingDetailSearch() {
      this.filter.page = 1;
      this.getBillingDetail();
    },

    downloadFile() {
      // Convert Object to JSON if not
      var jsonObject = this.billingDetail;
      var array =
        typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;

      var Head = [
        [
          '"Transaction For"',
          '"Payment Method"',
          '"Amount"',
          '"Date Created"',
        ],
      ];

      var row = [];
      for (var i = 0; i < array.length; i++) {
        row.push({
          key1: '"' + array[i].type + '"',
          key2: '"' + array[i].payment_method + '"',
          key3: '"$' + array[i].amount + '"',
          key4: '"' + array[i].created_at + '"',
        });
      }

      for (var item = 0; item < row.length; ++item) {
        Head.push([
          row[item].key1,
          row[item].key2,
          row[item].key3,
          row[item].key4,
        ]);
      }

      var csvRows = [];
      for (var cell = 0; cell < Head.length; ++cell) {
        csvRows.push(Head[cell].join(","));
      }

      var csvString = csvRows.join("\n");
      let csvFile = new Blob([csvString], {
        type: "text/csv",
      });
      let downloadLink = document.createElement("a");
      downloadLink.download = "Billing.csv";
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },

    changePagination() {
      this.filter.page = 1;
      this.getBillingDetail();
    },

    viewInvoice(onHold, id, type){
      if(onHold){
        toast.error('Invoice unavailable: Links on hold', {
          timeout: 4000,
        });
      }else{
        if(type == 'Order'){
          var orderRow = this.billingDetail.filter(x => x.id === id)[0];
          if (orderRow && orderRow.order_type === 'custom_order') {
            this.openCustomOrderPopup({
              amount: orderRow.amount,
              date: orderRow.created_at_formatted,
              description: orderRow.order_title || orderRow.description || '',
              invoice_no: orderRow.invoice_no || '',
              paid_via_invoice: !!orderRow.paid_via_invoice,
              payment_method: orderRow.payment_method,
              last4: orderRow.last4,
            });
            return;
          }
          if (this.$route.query) {
            this.$router.push({
              path: `/invoice/${id}`,
              query: this.$route.query
            });
          } else {
            this.$router.push(`/invoice/${id}`);
          }
        } else if(type == 'Balance'){
          var arr = this.billingDetail;
          arr = arr.filter(x => x.id === id);
          this.walletTopupData.amount = arr[0].amount;
          this.walletTopupData.date = arr[0].created_at_formatted;
          this.walletTopupData.invoice_no = arr[0].invoice_no || '';
          this.walletTopupData.paid_via_invoice = !!arr[0].paid_via_invoice;
          if(arr[0].payment_method == 'Card'){
            this.walletTopupData.payment_method = arr[0].payment_method + ' ' + arr[0].last4;
          }else if(arr[0].payment_method == 'Admin'){
            this.walletTopupData.payment_method = 'Added by Admin';
          }else{
            this.walletTopupData.payment_method = arr[0].payment_method;
          }
          this.showWalletTopupModal = true;
        } else if(type == 'Custom'){
          var customRow = this.billingDetail.filter(x => x.id === id)[0];
          this.openCustomOrderPopup({
            amount: customRow.amount,
            date: customRow.created_at_formatted,
            description: customRow.description || '',
            invoice_no: customRow.invoice_no || '',
            paid_via_invoice: !!customRow.paid_via_invoice,
            payment_method: customRow.payment_method,
            last4: customRow.last4,
          });
        }
      }
    },
    openCustomOrderPopup(data) {
      this.customPaymentData.amount = data.amount;
      this.customPaymentData.date = data.date;
      this.customPaymentData.description = data.description || '';
      this.customPaymentData.invoice_no = data.invoice_no || '';
      this.customPaymentData.paid_via_invoice = !!data.paid_via_invoice;
      if (data.payment_method == 'Card') {
        this.customPaymentData.payment_method = data.payment_method + ' ' + (data.last4 || '');
      } else if (data.payment_method == 'Admin') {
        this.customPaymentData.payment_method = 'Added by Admin';
      } else {
        this.customPaymentData.payment_method = data.payment_method || '';
      }
      this.showCustomPaymentModal = true;
    },
    closeModal(){
      this.showWalletTopupModal = false;
    },
    closeCustomModal(){
      this.showCustomPaymentModal = false;
    },
    goToOrderLinks(){
      this.showWalletTopupModal = false;
      window.location = window.location.origin + "/product";
    }
  },

  computed: {},
};
</script>
 